<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <h1 class="title is-4">Locations</h1>
      <div class="mt-3">
        <div v-if="waiting">
          <span class="icon is-medium is-size-4">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </div>
        <div v-else>
          <table class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th>#</th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('id')">Id</span>
                  <span class="icon" v-if="sortOption.field == 'id'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('nsId')">NS id</span>
                  <span class="icon" v-if="sortOption.field == 'nsId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('name')">Name</span>
                  <span class="icon" v-if="sortOption.field == 'name'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('city')">City</span>
                  <span class="icon" v-if="sortOption.field == 'city'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('state')">State</span>
                  <span class="icon" v-if="sortOption.field == 'state'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('country')">Country</span>
                  <span class="icon" v-if="sortOption.field == 'country'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="action-column">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in showingLocations" :key="'location-' + v.id" class="vendor-row" :class="{'has-background-white-ter': v.id == lastEditing}" :id="'location-'+v.id">
                <td>{{i+1}}</td>
                <td>{{v.id}}</td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.nsId}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.nsId">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.name}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.name">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.city}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.city">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.state}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.state">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.country}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.country">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="action-column">
                  <span class="vendor-actions">
                    <a @click="setEditingItem(v)">
                      <span class="icon">
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                    <a class="has-text-danger ml-3" @click="deleteLocation(v)">
                      <span class="icon">
                        <i class="fas fa-trash"></i>
                      </span>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <button class="button" @click="addLocation">
                    <span class="icon">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span>New</span>
                  </button>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat'

export default {
  name: 'Locations',
  data () {
    return {
      error: '',
      waiting: false,
      locations: [],
      sortOption: {
        field: 'id',
        asc: true,
      },
      editingItem: null,
      lastEditing: null,
      updating: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    showingLocations () {
      var sort = this.sortOption
      var sortedLocations = [...this.locations]
      sortedLocations.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (sort.field == 'id') {
          return sort.asc ? va - vb : vb - va
        }
        if (!va && !vb){
          return 0
        }
        if(!va) {
          return sort.asc ? 1 : -1
        }
        if (!vb) {
          return sort.asc ? -1 : 1
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedLocations
    },
  },
  methods: {
    getLocations () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-locations/').then(resp => {
        var locations = resp.body
        this.locations = locations
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    changeSortOption (field) {
      if (this.sortOption.field == field) {
        this.sortOption.asc = !this.sortOption.asc
        return
      }
      this.sortOption.field = field
    },
    setEditingItem (location) {
      if (this.editingItem && this.editingItem.id == location.id) {
        this.editingItem = null
        this.lastEditing = null
        return
      }
      this.editingItem = {...location}
      this.lastEditing = location.id
    },
    updateEditingItem () {
      this.updating = true
      this.$http.post(this.server + '/myapp/update-location/', this.editingItem).then(resp => {
        this.updating = false
        this.updateLocationFromUpdating()
        this.scrollToLocation(this.editingItem.id)
        this.editingItem = null
      }, err => {
        this.error = err.body
        this.updating = false
      })
    },
    deleteLocation (location) {
      var confirm = {
        title: 'Delete location',
        message: 'Are you sure to remove this location: ' + JSON.stringify(location) + '?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.deleteLocationConfirmed,
          args: [location]
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    deleteLocationConfirmed (location) {
      this.$http.post(this.server + '/myapp/delete-location/', {id: location.id}).then(resp => {
        var index = this.locations.findIndex(v => v.id == location.id)
        this.locations.splice(index, 1)
      }, err => {
        this.error = err.body
      })
    },
    addLocation () {
      var confirm = {
        title: 'Add location',
        message: 'Are you sure to add an empty location?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.addlocationConfirmed,
          args: []
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    addLocationConfirmed () {
      var message = {nsId: '', name: '', city: '', state: '', country: ''}
      this.$http.post(this.server + '/myapp/create-location/', message).then(resp => {
        var location = resp.body
        this.locations.push(location)
        this.scrollToLocation(location.id)
      }, err => {
        this.error = err.body
      })
    },
    updateLocationFromUpdating() {
      var index = this.locations.findIndex(v => v.id == this.editingItem.id)
      this.locations.splice(index, 1, this.editingItem)
    },
    scrollTolocation(locationId) {
      setTimeout(() => {
        const targetElement = document.getElementById("location-" + locationId);
        if (targetElement) {
          targetElement.scrollIntoView({ 
            behavior: "smooth", // "auto" for instant jump
            block: "start",     // Vertically aligns to "start", "center", "end", or "nearest"
            inline: "nearest"   // Horizontally aligns the element
          });
        }
      }, 1000)
    },
  },
  mounted () {
    this.$nextTick(function () {
      this.getLocations()
    })
  },
}
</script>

<style scoped lang="scss">
.vendor-row .vendor-actions {
  display: none;
}

.vendor-row:hover .vendor-actions {
  display: block;
}

.action-column {
  width: 100px;
}

.data-column {
  min-width: 150px;
}
</style>
